import { styled } from '@mui/material/styles';
import { NumericFormat } from 'react-number-format';

export const StyledNumericInput = styled(NumericFormat, { label: 'NumericFormatInput' })(
  ({ theme: { direction } }) => ({
    textAlign: direction === 'rtl' ? 'end' : 'start',
  }),
);
